import BaseComponent from '@/components/base';

export default class FlyoutPromo extends BaseComponent {
  style = `
   <style>
    .discount-checkout-container {
      position: sticky;
      bottom: 110px;
      left: 100%;
      background-color: #D2EAE5;
      min-height: 40px;
      width: 20%;
      font-size: 16px;
      z-index: 2000;
      box-shadow: 0px -4px 8px 0px rgba(0, 0, 0, 0.12);
      border-radius: 11px 0 0 11px;
      padding: 10px 20px;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    @media only screen and (max-width: 768px) {
      .discount-checkout-container {
        width: 55%;
        height: 40px;
        font-size: 14px;
      }
    }

  </style>
  `;
  render() {
    return `
    ${this.style}
    <div id="stickyPromo" class="discount-checkout-container">
        <div class="discount-checkout-text body-font-1">
            ${this.data.description.value}
        </div>
    </div>
`;
  }
}
